import { decodeHTML } from 'entities';
import { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { getPAGAA000, postPAGAC010 } from '../../../services/Api';
import Nav from '../../../shared/components/Nav';
import Pagination from '../../../shared/components/Pagination';
import { MENU_DENTAL_PLUS } from '../../../shared/constants/app';
import { updateMenuVisibility } from '../../../utils';
const PAGAC010 = () => {
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [searchParams, setSearchParam] = useSearchParams();
    const page = Number(searchParams.get('page')) || 1;
    const [pages, setPages] = useState({});
    // const [guBun, setGuBun] = useState('');
    const [keyword, setKeyword] = useState('');
    const [dentalPlusMenu, setDentalPlusMenu] = useState([]);

    useEffect(() => {
        getPAGAA000()
            .then(({ data }) => {
                const updatedDentalPlusMenu = updateMenuVisibility(data, MENU_DENTAL_PLUS);
                setDentalPlusMenu(updatedDentalPlusMenu);
            })
            .catch((error) => console.log(error));
    }, []);

    const inputChange = (e) => {
        setKeyword(e.target.value);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            getListData();
            setSearchParam(1);
        }
    };

    const handleSearchIconClick = () => {
        getListData();
        setSearchParam(1);
    };
    const getListData = async () => {
        postPAGAC010({ page, keyword: keyword })
            .then(({ data }) => {
                setData(data.data);
                setPages(data.info);
            })
            .catch((error) => console.log(error));
    };
    useEffect(() => {
        getListData();
        //eslint-disable-next-line
    }, [page]);

    const borderColorItem = (gubun) => {
        switch (gubun) {
            case 'INTERVIEW':
                return 'orange';
            case 'COLUMN':
                return '';
            case 'QNA':
                return '';
            default:
                return '';
        }
    };
    const textGubunItem = (gubun) => {
        switch (gubun) {
            case 'INTERVIEW':
                return '덴탈탐방';
            case 'COLUMN':
                return '덴탈칼럼';
            case 'QNA':
                return 'QNA';
            default:
                return '';
        }
    };
    const handleDetailItem = (seq, gubun, textGubun) => {
        navigate('/pagac020', { state: { seq: seq, gubun: gubun, textGubun: textGubun } });
    };

    return (
        <div id="content">
            <Nav menu={dentalPlusMenu} />
            <div id="tableVolunteer">
                <div className="header-table">
                    <div className="header-left">
                        <h3 className="vln__tit" style={{ paddingTop: 0 }}>
                            덴탈 매거진
                        </h3>
                    </div>
                    <div className="header-right gray">
                        <input
                            type="text"
                            placeholder="검색어 입력"
                            value={keyword}
                            onChange={inputChange}
                            onKeyDown={handleKeyDown}
                        />
                        <i className="icon icon-magnifying-glass-line" onClick={handleSearchIconClick}></i>
                    </div>
                </div>
                <div className="vln-mgzn">
                    <table className="vln-mgzn__table">
                        <thead>
                            <tr>
                                <th>구분</th>
                                <th>제목</th>
                                <th>연자/소속</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data && data.length > 0 ? (
                                data.map((item, index) => (
                                    <tr key={item.seq}>
                                        <td className="wd165">
                                            <span className={`vln-mgzn__gb ${borderColorItem(item.gubun)}`}>
                                                {textGubunItem(item.gubun)}
                                            </span>
                                        </td>
                                        <td
                                            className="text-left"
                                            onClick={() =>
                                                handleDetailItem(
                                                    item.seq,
                                                    borderColorItem(item.gubun),
                                                    textGubunItem(item.gubun),
                                                )
                                            }
                                        >
                                            <Link className="vln-mgzn__link"> {decodeHTML(item.title)}</Link>
                                        </td>
                                        <td className="wd260 pd10">
                                            <div className="vln-mgzn__nt">
                                                {/* <span>강익재</span>
                                                <span>NY 치과</span> */}
                                                <span>{item.columnist}</span>
                                                <br />
                                                <span>{item.bizCompany}</span>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="3">데이터없습니다</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
                <Pagination pages={pages} />
            </div>
        </div>
    );
};

export default PAGAC010;
